<template>
    <div
        id="list-subscriptionStatuses-component"
        class="w-full h-full flex flex-col"
    >
        <custom-simple-select
            v-model="option"
            class="w-full"
            label="Estado de suscripción"
            :options="subscriptionStatusOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { subscriptionStatusFilterCodes } from "@/common/fields/platform-subscription-codes";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "SubscriptionStatusSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: ""
    }),
    computed: {
        subscriptionStatusOptions() {
            return Object.entries(subscriptionStatusFilterCodes).map(
                ([key, value]) => ({
                    label: value,
                    value: key
                })
            );
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.setInput(this.itemCurrent);
    },
    methods: {
        onInput() {
            this.$emit("change", this.option);
        },
        setInput(value) {
            this.option = value;
        }
    }
};
</script>
